import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import EmailIcon from "@material-ui/icons/Email";
import SmsIcon from "@material-ui/icons/Sms";

/**
 * Ícone do canal a partir de `Whatsapps.type`.
 *
 * Baileys e Cloud API são os dois sabores de WhatsApp e compartilham o ícone —
 * também é o padrão quando o tipo não veio no payload. Os demais canais têm
 * ícone próprio para que a conexão seja reconhecida de relance na bolha da
 * mensagem e no card do chamado.
 */
export const channelIconComponent = type => {
  switch (String(type || "").toLowerCase()) {
    case "instagram":
      return InstagramIcon;
    case "email":
      return EmailIcon;
    case "sms":
      return SmsIcon;
    default:
      return WhatsAppIcon;
  }
};

const ChannelIcon = ({ type, ...props }) => {
  const Icon = channelIconComponent(type);
  return <Icon {...props} />;
};

export default ChannelIcon;
